export const BENEFIT_INTEGRATIONS = 'benefit-integrations'
export const NEW_BENEFIT_INTEGRATION = `${BENEFIT_INTEGRATIONS}/new`

export const IDEON = 'ideon'
export const IDEON_CONFIG = `${IDEON}/config`
export const IDEON_AGENT_DETAIL = `${IDEON_CONFIG}/:ideonAgentId`

export const NOYO = 'noyo'
export const NOYO_ISSUES = `${NOYO}/issues`

/** Absolute path for router navigation */
export const ideonConfigPath = () => `/${BENEFIT_INTEGRATIONS}/${IDEON_CONFIG}`
export const ideonAgentDetailPath = (ideonAgentId: string) =>
  `${ideonConfigPath()}/${ideonAgentId}`
export const noyoIssuesPath = () => `/${BENEFIT_INTEGRATIONS}/${NOYO_ISSUES}`
